/* eslint-disable import/no-default-export */
import { combineReducers } from 'redux';

import notificationsPane, {
  NotificationsPaneState,
} from './notifications-pane';
import overlay, { OverlayState } from './overlay';

export interface UiState {
  notificationsPane: NotificationsPaneState;
  overlay: OverlayState;
}

export default combineReducers({
  notificationsPane,
  overlay,
});
